import { useState } from "react";

import info from "../../assets/svg/info.svg";
import { shouldUseEntry } from "../../helpers/steps.ts";
import { useVehicleSelection } from "../../providers/VehicleSelectionContext.tsx";
import { ComplexBundle } from "../../types/Product.ts";
import Header from "../elements/Header.tsx";
import Modal from "../elements/Modal.tsx";
import { FreeTextDropdown } from "./entry-types/FreeTextDropdown.tsx";
import { InformativeText } from "./entry-types/InformativeText.tsx";
import { ProductDropdown } from "./entry-types/ProductDropdown.tsx";
import { ProductsFreeTextChecklist } from "./entry-types/ProductsFreeTextChecklist.tsx";

interface Props {
  step: ComplexBundle.Step;
  index: number;
}

export const Step = ({ step, index }: Props) => {
  const [modalOpen, setModalOpen] = useState(false);
  const { orderMode, selectedOptions } = useVehicleSelection();

  if (step.entries.length === 0) {
    return null; // No entries to display
  }

  const typeMap = {
    "informative-text": InformativeText,
    "free-text-dropdown": FreeTextDropdown,
    "product-dropdown": ProductDropdown,
    "products-free-text-list": null, // Not applicable in this context
    "products-free-text-checklist": ProductsFreeTextChecklist,
  };

  const entries = step.entries
    .map((entry, entryIndex) => {
      if (!shouldUseEntry(entry, orderMode, selectedOptions)) {
        return null;
      }
      const ElementType = typeMap[entry.entry_type];

      return ElementType ? (
        <ElementType
          step={step}
          stepIndex={index}
          entry={entry}
          entryIndex={entryIndex}
          key={entryIndex}
        />
      ) : null;
    })
    .filter(Boolean);

  if (entries.length === 0) {
    return null;
  }

  return (
    <div>
      <Header size="lg" className="flex justify-between items-center mb-3">
        {step.step_name}
        {step.step_description && (
          <img
            src={info}
            className="h-[25px] w-[25px] cursor-pointer"
            onClick={() => setModalOpen(true)}
          />
        )}
      </Header>

      {step.step_description && modalOpen && (
        <Modal onClose={() => setModalOpen(false)}>
          <Header size="2xl" hideUnderline className="mb-4">
            {step.step_name}
          </Header>
          <div
            className="text-sm"
            dangerouslySetInnerHTML={{ __html: step.step_description }}
          />
        </Modal>
      )}
      <div className="flex flex-col gap-4">{entries}</div>
    </div>
  );
};
